export default {
  bagFees: 'Det kan påløpe ekstra bagasjeavgifter',
}
